/* v2.5.1 */
/* ============================================
   GOOD HABITS – Hälsoprofil (Lead Gen) v4.1
   gh-halsoprofil.js
   ============================================
   Kräver: gh-algorithm.js (GHAlgorithm)
   Laddas BARA på /pages/halsoprofil.

   v4.1 CHANGELOG:
   - Konsekvensbaserade tooltip-texter
   - Förbättrad tolkningstext (S3)
   - Dynamisk S5-titel med kcal-värde
   - Personaliserad S6-copy (4 varianter: mål + diabetes)
   - Uppdaterad micro-copy genomgående
   ============================================ */

(function() {
  'use strict';

  var API_URL = '/apps/gh';

  /* ── State ── */
  var state = {
    step: 1,
    gender: null,
    age: null,
    height: null,
    weight: null,
    activity: null,
    goal: null,
    diabetes: null,
    firstName: null,
    email: null
  };

  var result = null;
  var movementResult = null;  /* Resultat med minExercise for movement.needed-fall */
  var minExerciseKcal = 0;   /* Direkt-beraknad minExercise (undviker minifierings-bugg) */
  var TOTAL_STEPS = 7;

  /* ── DOM refs ── */
  var progressFill = document.getElementById('ghHpProgressFill');
  var stepsContainer = document.getElementById('ghHpSteps');
  var s3 = document.getElementById('gh-hp-s3');
  var s4 = document.getElementById('gh-hp-s4');
  var s5 = document.getElementById('gh-hp-s5');
  var s6 = document.getElementById('gh-hp-s6');
  var numbersEl = document.getElementById('ghHpNumbers');
  var interpEl = document.getElementById('ghHpInterpretation');
  var macrosEl = document.getElementById('ghHpMacros');
  var firstNameInput = document.getElementById('ghHpFirstName');
  var lastNameInput = document.getElementById('ghHpLastName');
  var emailInput = document.getElementById('ghHpEmail');
  var emailBtn = document.getElementById('ghHpEmailBtn');
  var emailBtnText = document.getElementById('ghHpEmailBtnText');
  var emailError = document.getElementById('ghHpEmailError');

  /* ── SVG ── */
  var INFO_ICON = '<svg class="gh-hp-tip-svg" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.4"/><path d="M8 7.2V11" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/><circle cx="8" cy="5.2" r="0.8" fill="currentColor"/></svg>';

  /* ── Tooltips: konsekvensbaserade (v4.1) ── */
  var BASELINE_TOOLTIPS = [
    { match: 'BMR',         title: 'VILOF\u00D6RBR\u00C4NNING',  text: 'S\u00E5 mycket energi br\u00E4nner din kropp bara genom att existera: andas, t\u00E4nka, h\u00E5lla kroppstemperaturen uppe. \u00C4ven om du l\u00E5g still hela dagen.' },
    { match: 'TDEE',        title: 'DAGLIG F\u00D6RBR\u00C4NNING', text: 'Din vilof\u00F6rbr\u00E4nning plus all vardagsr\u00F6relse: g\u00E5, st\u00E5, jobba. Det h\u00E4r \u00E4r vad din kropp faktiskt g\u00F6r av med en vanlig dag.' },
    { match: 'LKALORIER',   title: 'DITT RIKTV\u00C4RDE',       text: 'Antalet kalorier du b\u00F6r sikta p\u00E5 varje dag, justerat efter ditt m\u00E5l. Inte en exakt regel, men en utg\u00E5ngspunkt som fungerar.' },
    { match: 'RIKTV',       title: 'DITT RIKTV\u00C4RDE',       text: 'Antalet kalorier du b\u00F6r sikta p\u00E5 varje dag, justerat efter ditt m\u00E5l. Inte en exakt regel, men en utg\u00E5ngspunkt som fungerar.' },
    { match: 'BMI',         title: 'BODY MASS INDEX',   text: 'Ett grovt m\u00E5tt som j\u00E4mf\u00F6r vikt med l\u00E4ngd. S\u00E4ger inget om muskelmassa eller hur du m\u00E5r, men ger en fingervisning.' },
    { match: 'PROTEIN',     title: 'PROTEIN',            text: 'Byggstenarna som reparerar muskler, h\u00E5ller dig m\u00E4tt l\u00E4ngre och ger kroppen struktur. M\u00E5nga \u00E4ter f\u00F6r lite, speciellt n\u00E4r man vill minska fett.' },
    { match: 'FETT',        title: 'FETT',               text: 'Inte fienden. Fett beh\u00F6vs f\u00F6r hormoner, cellmembran och att ta upp vitaminer. Det handlar om r\u00E4tt m\u00E4ngd, inte att undvika det.' },
    { match: 'KOLHYDRATER', title: 'KOLHYDRATER',        text: 'Kroppens snabbaste energik\u00E4lla. Hj\u00E4rnan kr\u00E4ver minst 130g per dag bara f\u00F6r att fungera. Resten \u00E4r br\u00E4nsle f\u00F6r allt du g\u00F6r.' },
    { match: 'BTS LEVEL',   title: 'BTS LEVEL',          text: 'Din level avg\u00F6r hur dina makro\u00E4mnen f\u00F6rdelas. Alla startar p\u00E5 Level 1. Niv\u00E5n justeras av din coach.' },
    { match: 'VARDAGSR',    title: 'VARDAGSR\u00D6RELSE',    text: 'Allt du g\u00F6r utan att t\u00E4nka p\u00E5 det som tr\u00E4ning: g\u00E5 till bussen, ta trapporna, handla mat, st\u00E4da hemma. Det \u00E4r basen i din f\u00F6rbr\u00E4nning och p\u00E5verkar hur mycket du kan \u00E4ta varje dag. Sm\u00E5 vanor i vardagen g\u00F6r oftast st\u00F6rre skillnad \u00E4n enstaka gympass.' },
    { match: 'TR\u00C4NING',       title: 'MEDVETEN R\u00D6RELSE',    text: 'R\u00F6relse du g\u00F6r med avsikt: en promenad, jogging p\u00E5 plats, hemmatr\u00E4ning eller ett gympass. Det beh\u00F6ver inte vara stort. Redan 10\u201315 minuter om dagen kan f\u00F6r\u00E4ndra b\u00E5de hur du m\u00E5r och vad din kropp klarar av. Det fina \u00E4r att ju mer du r\u00F6r dig, desto mer f\u00E5r du \u00E4ta, och desto b\u00E4ttre funkar din kropp.' }
  ];

  /* ── Tooltip system ── */
  var tipEl = null;
  var tipTitleEl = null;
  var tipTextEl = null;
  var tipHideTimer = null;

  function createTooltip() {
    tipEl = document.createElement('div');
    tipEl.className = 'gh-hp-tip';

    var closeBtn = document.createElement('span');
    closeBtn.className = 'gh-hp-tip__close';
    closeBtn.textContent = '\u00D7';
    closeBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      hideTooltip();
    });

    tipTitleEl = document.createElement('strong');
    tipTitleEl.className = 'gh-hp-tip__title';

    tipTextEl = document.createElement('span');
    tipTextEl.className = 'gh-hp-tip__text';

    var body = document.createElement('div');
    body.className = 'gh-hp-tip__body';
    body.appendChild(tipTitleEl);
    body.appendChild(tipTextEl);

    tipEl.appendChild(closeBtn);
    tipEl.appendChild(body);
    document.body.appendChild(tipEl);

    tipEl.addEventListener('mouseenter', function() {
      clearTimeout(tipHideTimer);
    });
    tipEl.addEventListener('mouseleave', function() {
      hideTooltip();
    });
    tipEl.addEventListener('click', function(e) {
      e.stopPropagation();
    });

    document.addEventListener('click', function() {
      hideTooltip();
    });
  }

  function showTooltip(icon, data) {
    if (!tipEl) createTooltip();
    clearTimeout(tipHideTimer);

    tipTitleEl.textContent = data.title;
    tipTextEl.textContent = data.text;
    tipEl.classList.add('gh-hp-tip--visible');

    var rect = icon.getBoundingClientRect();
    var popupW = 300;
    var winW = window.innerWidth;

    var topPos = rect.bottom + 10;
    if (topPos + 140 > window.innerHeight) {
      topPos = rect.top - 140;
    }

    var leftPos = rect.left + (rect.width / 2) - (popupW / 2);
    if (leftPos < 12) leftPos = 12;
    if (leftPos + popupW > winW - 12) leftPos = winW - popupW - 12;

    tipEl.style.top = topPos + 'px';
    tipEl.style.left = leftPos + 'px';
  }

  function hideTooltip() {
    if (tipEl) tipEl.classList.remove('gh-hp-tip--visible');
  }

  function scheduleHide() {
    clearTimeout(tipHideTimer);
    tipHideTimer = setTimeout(hideTooltip, 200);
  }

  function findTooltipData(labelText) {
    var upper = labelText.toUpperCase();
    for (var i = 0; i < BASELINE_TOOLTIPS.length; i++) {
      if (upper.indexOf(BASELINE_TOOLTIPS[i].match) > -1) {
        return BASELINE_TOOLTIPS[i];
      }
    }
    return null;
  }

  function initTooltips(container) {
    var icons = container.querySelectorAll('.gh-hp-tip-icon');
    for (var i = 0; i < icons.length; i++) {
      (function(icon) {
        if (icon.dataset.tipBound) return;
        icon.dataset.tipBound = '1';

        var parentEl = icon.closest('[data-tip-label]');
        if (!parentEl) parentEl = icon.parentNode;
        var labelStr = parentEl.getAttribute('data-tip-label') || parentEl.textContent || '';
        var data = findTooltipData(labelStr);
        if (!data) return;

        icon.addEventListener('click', function(e) {
          e.stopPropagation();
          showTooltip(icon, data);
        });
        icon.addEventListener('mouseenter', function() {
          showTooltip(icon, data);
        });
        icon.addEventListener('mouseleave', function() {
          scheduleHide();
        });
      })(icons[i]);
    }
  }

  /* ── Progress / Stepper ── */
  var stepperText = document.getElementById('ghHpStepperText');

  function updateProgress() {
    if (!progressFill) return;
    var pct = (state.step / TOTAL_STEPS) * 100;
    progressFill.style.width = pct + '%';
    if (stepperText) {
      stepperText.textContent = 'STEG ' + state.step + ' AV ' + TOTAL_STEPS;
    }
  }

  /* ── Step transitions ── */
  function showStep(n) {
    var steps = stepsContainer.querySelectorAll('.gh-hp-s2__step');
    for (var i = 0; i < steps.length; i++) {
      var el = steps[i];
      var stepNum = parseInt(el.getAttribute('data-step'));

      if (stepNum == n) {
        el.style.display = 'block';

        /* Reset step 7 elements when navigating back to it */
        if (stepNum == 7) {
          var h7 = document.getElementById('ghHpStep7Header');
          var c7 = document.getElementById('ghHpStep7Choices');
          var conf = document.getElementById('ghHpDiabetesConfirm');
          var comp = document.getElementById('ghHpCompletion');
          var stp = document.getElementById('ghHpStepper');
          if (h7) h7.style.display = '';
          if (c7) c7.style.display = '';
          if (conf) conf.style.display = 'none';
          if (comp) comp.style.display = 'none';
          if (stp) stp.style.display = '';
          state.diabetes = null;
          var dBtns = el.querySelectorAll('.gh-hp-s2__diabetes-btn');
          for (var j = 0; j < dBtns.length; j++) {
            dBtns[j].classList.remove('gh-hp-s2__diabetes-btn--selected');
          }
        }

        el.offsetHeight; /* force reflow */
        el.classList.add('gh-hp-s2__step--active');

        var firstInput = el.querySelector('input[type="number"]');
        if (firstInput) {
          setTimeout(function() { firstInput.focus(); }, 250);
        }
      } else {
        el.classList.remove('gh-hp-s2__step--active');
        el.style.display = 'none';
      }
    }
  }

  function goToStep(n) {
    state.step = n;
    updateProgress();
    showStep(n);
  }

  function goBack() {
    if (state.step > 1) {
      goToStep(state.step - 1);
    }
  }

  /* ── Form handlers ── */
  function handleGender(val) {
    state.gender = val;
    pushTracking('baseline_form_start');
    goToStep(2);
  }

  function handleNumericNext(field, min, max) {
    var input = document.getElementById('ghHpInput_' + field);
    if (!input) return;
    var val = parseInt(input.value, 10);
    if (isNaN(val) || val < min || val > max) {
      input.classList.add('gh-hp-s2__input--error');
      return;
    }
    input.classList.remove('gh-hp-s2__input--error');
    state[field] = val;
    goToStep(state.step + 1);
  }

  function handleActivity(val) {
    state.activity = val;
    var cards = stepsContainer.querySelectorAll('.gh-hp-s2__activity-card');
    for (var i = 0; i < cards.length; i++) {
      if (parseInt(cards[i].getAttribute('data-value')) == val) {
        cards[i].classList.add('gh-hp-s2__activity-card--selected');
      } else {
        cards[i].classList.remove('gh-hp-s2__activity-card--selected');
      }
    }
    setTimeout(function() { goToStep(6); }, 200);
  }

  function handleGoal(val) {
    /* BMI-sparr: blockera "Ga ner i vikt" vid BMI < 18.5 (v2.4) */
    if (val == 'G\u00E5 ner i vikt' && state.weight && state.height) {
      var _hm = state.height / 100;
      var _bmi = state.weight / (_hm * _hm);
      if (_bmi < 18.5) {
        var goalRow = stepsContainer.querySelector('.gh-hp-s2__goal-row');
        var existing = goalRow.querySelector('.gh-hp-s2__goal-warning');
        if (!existing) {
          var warn = document.createElement('p');
          warn.className = 'gh-hp-s2__goal-warning';
          warn.style.cssText = 'font-size:14px;font-weight:500;line-height:1.6;color:#e84393;margin-top:16px;text-align:left;';
          warn.textContent = 'Utifr\u00E5n din vikt och l\u00E4ngd ser vi att fettminskning inte \u00E4r aktuellt f\u00F6r dig. V\u00E4lj ett annat m\u00E5l.';
          goalRow.appendChild(warn);
        }
        return;
      }
    }
    /* Rensa ev varning */
    var oldWarn = stepsContainer.querySelector('.gh-hp-s2__goal-warning');
    if (oldWarn) oldWarn.remove();

    state.goal = val;
    var btns = stepsContainer.querySelectorAll('.gh-hp-s2__goal-btn');
    for (var i = 0; i < btns.length; i++) {
      if (btns[i].getAttribute('data-value') == val) {
        btns[i].classList.add('gh-hp-s2__goal-btn--selected');
      } else {
        btns[i].classList.remove('gh-hp-s2__goal-btn--selected');
      }
    }
    setTimeout(function() { goToStep(7); }, 200);
  }

  function handleDiabetes(val) {
    state.diabetes = (val == 'Ja');
    var btns = stepsContainer.querySelectorAll('.gh-hp-s2__diabetes-btn');
    for (var i = 0; i < btns.length; i++) {
      if (btns[i].getAttribute('data-value') == val) {
        btns[i].classList.add('gh-hp-s2__diabetes-btn--selected');
      } else {
        btns[i].classList.remove('gh-hp-s2__diabetes-btn--selected');
      }
    }

    var confirmEl = document.getElementById('ghHpDiabetesConfirm');
    var header = document.getElementById('ghHpStep7Header');
    var choices = document.getElementById('ghHpStep7Choices');
    var completion = document.getElementById('ghHpCompletion');
    var stepper = document.getElementById('ghHpStepper');

    function showCompletion() {
      if (header) header.style.display = 'none';
      if (choices) choices.style.display = 'none';
      if (confirmEl) confirmEl.style.display = 'none';
      if (stepper) stepper.style.display = 'none';
      if (completion) completion.style.display = 'flex';
    }

    if (state.diabetes) {
      if (confirmEl) confirmEl.style.display = 'block';
      setTimeout(showCompletion, 1200);
    } else {
      setTimeout(showCompletion, 300);
    }
  }

  function handleShowProfile() {
    if (state.diabetes == null) return;

    result = GHAlgorithm.calculate({
      gender: state.gender,
      age: state.age,
      weight: state.weight,
      height: state.height,
      activityLevel: state.activity,
      goal: state.goal,
      algorithm: state.diabetes ? 'BTS' : 'MTH',
      btsLevel: 1,
      hasDiabetes: state.diabetes,
      exerciseKcal: 0
    });

    if (!result || !result.valid) return;

    /* Berakna minExercise DIREKT via publik funktion (Shopifys minifierare
       forstorer for-loopen inuti calculate(), sa vi anropar funktionen separat) */
    movementResult = null;
    minExerciseKcal = GHAlgorithm.calculateMinExercise(
      state.gender, parseInt(state.age), parseFloat(state.weight), parseFloat(state.height),
      parseInt(state.activity), state.goal, state.diabetes ? 'BTS' : 'MTH', 1
    ) || 0;
    if (minExerciseKcal > 0) {
      movementResult = GHAlgorithm.calculate({
        gender: state.gender,
        age: state.age,
        weight: state.weight,
        height: state.height,
        activityLevel: state.activity,
        goal: state.goal,
        algorithm: state.diabetes ? 'BTS' : 'MTH',
        btsLevel: 1,
        hasDiabetes: state.diabetes,
        exerciseKcal: minExerciseKcal
      });
    }

    pushTracking('baseline_form_complete');

    renderBaselineCards();
    renderInterpretation();

    s3.style.display = 'block';

    var s2El = document.getElementById('gh-hp-s2');
    if (s2El) s2El.style.display = 'none';

    /* Visa email-gate (S4): forifyll om inloggad */
    s4.style.display = 'block';
    if (isLoggedIn) {
      if (emailInput) emailInput.value = customerEmail;
      if (firstNameInput) firstNameInput.value = customerName;
    }

    /* Dynamisk S4-copy: malspecifik */
    var s4Body = document.querySelector('.gh-hp-s4__body');
    if (s4Body && result) {
      var displayKcal = (movementResult && movementResult.valid) ? movementResult.targetCalories : result.targetCalories;
      var s4Copy = '<strong>' + displayKcal.toLocaleString('sv-SE') + ' kcal om dagen.</strong> ';
      if (state.goal == 'Bygga muskler') {
        s4Copy += 'Men hur mycket protein beh\u00F6ver du f\u00F6r att faktiskt bygga muskler? Hur f\u00F6rdelar du fett och kolhydrater? Och vad h\u00E4nder med din plan n\u00E4r du \u00F6kar tr\u00E4ningsvolymen? Vi r\u00E4knar ut allt och l\u00E5ter dig testa i realtid.';
      } else if (state.goal == 'G\u00E5 ner i vikt') {
        s4Copy += 'Men hur f\u00F6rdelar du dem f\u00F6r att g\u00E5 ner utan att tappa muskler? Hur mycket protein beh\u00F6ver just du? Och vad h\u00E4nder om du l\u00E4gger till en kort promenad eller \u00E4ndrar dina vardagsvanor? Vi r\u00E4knar ut allt och l\u00E5ter dig testa i realtid.';
      } else {
        s4Copy += 'Men hur f\u00F6rdelar du dem? Hur mycket protein beh\u00F6ver just du? Och vad h\u00E4nder med din plan om du l\u00E4gger till lite mer r\u00F6relse i vardagen? Vi r\u00E4knar ut allt och l\u00E5ter dig testa i realtid.';
      }
      s4Body.innerHTML = s4Copy;
    }

    /* Blurrad S5 teaser: rendera makrokort + sliders med faktiska värden */
    renderMacroCards();
    renderMovementSliders();
    /* Sätt faktiska värden direkt (istället för countUp "0") */
    var teaserEls = s5.querySelectorAll('[data-count]');
    for (var ti = 0; ti < teaserEls.length; ti++) {
      var tVal = parseFloat(teaserEls[ti].getAttribute('data-count'));
      var tDec = parseInt(teaserEls[ti].getAttribute('data-decimals')) || 0;
      teaserEls[ti].textContent = tDec > 0 ? tVal.toFixed(tDec) : Math.round(tVal).toLocaleString('sv-SE');
    }
    s5.style.display = 'block';
    s5.classList.add('gh-hp-s5--teaser');
    setTimeout(function() {
      s5.classList.add('gh-hp-s5--visible');
    }, 100);

    setTimeout(function() {
      s3.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 100);

    observeCountUp(s3);
  }

  /* ── Rendering: S3 Baseline cards ── */
  function renderBaselineCards() {
    if (!numbersEl || !result) return;

    var icon = '<span class="gh-hp-tip-icon">' + INFO_ICON + '</span>';
    var bmiCategory = result.bmi.category;

    /* Riktvarde: om movement.needed, visa target MED minExercise */
    var displayTarget = (movementResult && movementResult.valid)
      ? movementResult.targetCalories
      : result.targetCalories;
    var targetMicro = (movementResult && movementResult.valid)
      ? 'Din kaloribudget (inkl. r\u00F6relse)'
      : 'Din kaloribudget';

    var html = '<div class="gh-hp-s3__cards-grid">';
    html += '<div class="gh-hp-s3__card"><span class="gh-hp-s3__card-label" data-tip-label="BMR">BMR ' + icon + '</span><span class="gh-hp-s3__card-value" data-count="' + result.bmr + '">0</span><span class="gh-hp-s3__card-unit">kcal</span><span class="gh-hp-s3__card-micro">Vilof\u00F6rbr\u00E4nning</span></div>';
    html += '<div class="gh-hp-s3__card"><span class="gh-hp-s3__card-label" data-tip-label="TDEE">TDEE ' + icon + '</span><span class="gh-hp-s3__card-value" data-count="' + result.tdee + '">0</span><span class="gh-hp-s3__card-unit">kcal</span><span class="gh-hp-s3__card-micro">Daglig f\u00F6rbr\u00E4nning</span></div>';
    html += '<div class="gh-hp-s3__card"><span class="gh-hp-s3__card-label" data-tip-label="BMI">BMI ' + icon + '</span><span class="gh-hp-s3__card-value" data-count="' + result.bmi.value + '" data-decimals="1">0</span><span class="gh-hp-s3__card-unit">' + bmiCategory + '</span><span class="gh-hp-s3__card-micro">Vikt/l\u00E4ngd</span></div>';
    html += '<div class="gh-hp-s3__card gh-hp-s3__card--highlight"><span class="gh-hp-s3__card-label" data-tip-label="M\u00C5LKALORIER">RIKTV\u00C4RDE ' + icon + '</span><span class="gh-hp-s3__card-value" data-count="' + displayTarget + '">0</span><span class="gh-hp-s3__card-unit">kcal/dag</span><span class="gh-hp-s3__card-micro">' + targetMicro + '</span></div>';
    html += '</div>';

    numbersEl.innerHTML = html;
    initTooltips(numbersEl);
  }

  /* ── Rendering: S3 Interpretation text (v4.1, konsekvensbaserad + movement-boxar) ── */
  function renderInterpretation() {
    if (!interpEl || !result) return;

    var html = '';
    var bmr = result.bmr;
    var tdee = result.tdee;
    var baseTarget = result.targetCalories;
    var actVal = state.activity;
    var bmiVal = result.bmi.value;
    var hasMovement = (movementResult && movementResult.valid);
    var displayTarget = hasMovement ? movementResult.targetCalories : baseTarget;

    /* Huvudtolkning: konsekvensbaserad */
    html += '<p class="gh-hp-s3__interp-text">';
    html += 'Din kropp f\u00F6rbr\u00E4nner ' + bmr.toLocaleString('sv-SE') + ' kcal i vila och ' + tdee.toLocaleString('sv-SE') + ' kcal totalt med din vardag.';
    html += '</p>';

    if (state.goal == 'G\u00E5 ner i vikt') {

      if (hasMovement) {
        /* Movement-boxar: forklara varfor riktvarde ar justerat */
        var minEx = minExerciseKcal;
        var examples = GHAlgorithm.getExerciseExamples(minEx, parseFloat(state.weight), state.goal);
        var bestEx = pickBestExample(examples);
        var exLabel = bestEx ? ('ex. ' + bestEx.minutes + ' min ' + bestEx.label.toLowerCase()) : (minEx + ' kcal');

        html += '<div class="gh-hp-s3__movement-notice">';
        html += '<p class="gh-hp-s3__movement-intro">' + baseTarget.toLocaleString('sv-SE') + ' kcal r\u00E4cker inte f\u00F6r dina minimibehov av protein, fett och kolhydrater. D\u00E4rf\u00F6r ing\u00E5r daglig r\u00F6relse i din plan.</p>';

        html += '<div class="gh-hp-s3__movement-boxes">';

        /* Box 1: Utan rorelse */
        html += '<div class="gh-hp-s3__movement-box gh-hp-s3__movement-box--without">';
        html += '<span class="gh-hp-s3__movement-box-label">Utan r\u00F6relse</span>';
        html += '<span class="gh-hp-s3__movement-box-value">' + baseTarget.toLocaleString('sv-SE') + ' kcal</span>';
        html += '<span class="gh-hp-s3__movement-box-note">Otillr\u00E4cklig n\u00E4ring</span>';
        html += '</div>';

        /* Box 2: Med rorelse */
        html += '<div class="gh-hp-s3__movement-box gh-hp-s3__movement-box--with">';
        html += '<span class="gh-hp-s3__movement-box-label">Med ' + minEx + ' kcal r\u00F6relse/dag</span>';
        html += '<span class="gh-hp-s3__movement-box-value">' + displayTarget.toLocaleString('sv-SE') + ' kcal</span>';
        html += '<span class="gh-hp-s3__movement-box-note">' + exLabel + '</span>';
        html += '</div>';

        html += '</div>';  /* boxes */

        html += '<p class="gh-hp-s3__movement-explain">R\u00F6relsen h\u00F6jer din totalf\u00F6rbr\u00E4nning. 20% av \u00F6kningen driver fettminskningen: resten blir extra matbudget s\u00E5 att n\u00E4ringen r\u00E4cker till. ';
        html += 'Ditt riktv\u00E4rde: <strong>' + displayTarget.toLocaleString('sv-SE') + ' kcal/dag</strong>.</p>';
        html += '</div>';  /* movement-notice */
      } else {
        /* Normalt fall: deficit utan movement */
        var deficit = tdee - baseTarget;
        html += '<p class="gh-hp-s3__interp-text">';
        html += 'Ett underskott p\u00E5 ' + deficit.toLocaleString('sv-SE') + ' kcal ger kontrollerad fettminskning utan att kroppen bromsar in. ';
        html += 'Ditt riktv\u00E4rde: <strong>' + displayTarget.toLocaleString('sv-SE') + ' kcal/dag</strong>.';
        html += '</p>';
      }
    } else if (state.goal == 'Bygga muskler') {
      var surplus = displayTarget - tdee;
      html += '<p class="gh-hp-s3__interp-text">';
      html += 'Ett \u00F6verskott p\u00E5 ' + surplus.toLocaleString('sv-SE') + ' kcal ger kroppen byggmaterial. Utan tr\u00E4ning lagras det som fett: regelbunden styrketr\u00E4ning \u00E4r det som g\u00F6r skillnaden. ';
      html += 'Ditt riktv\u00E4rde: <strong>' + displayTarget.toLocaleString('sv-SE') + ' kcal/dag</strong>.';
      html += '</p>';
    } else {
      html += 'Du siktar p\u00E5 att forma kroppen. Det betyder att h\u00E5lla dig n\u00E4ra ';
      html += '<strong>' + tdee.toLocaleString('sv-SE') + ' kcal per dag</strong>.';
      html += '</p>';
    }

    /* BMI-notis: tydlig vid extrema varden */
    if (bmiVal < 16) {
      html += '<div class="gh-hp-s3__disclaimer">Ditt BMI p\u00E5 ' + bmiVal + ' tyder p\u00E5 kraftig undervikt. Vi rekommenderar starkt att du r\u00E5dg\u00F6r med v\u00E5rden. Siffrorna nedan \u00E4r en utg\u00E5ngspunkt, inte en plan att f\u00F6lja p\u00E5 egen hand.</div>';
    } else if (bmiVal < 18.5) {
      html += '<div class="gh-hp-s3__disclaimer">Ditt BMI p\u00E5 ' + bmiVal + ' ligger under normalspannet. Det \u00E4r viktigt att s\u00E4kerst\u00E4lla att du f\u00E5r tillr\u00E4ckligt med energi och n\u00E4ring.</div>';
    } else if (bmiVal < 25) {
      html += '<p class="gh-hp-s3__bmi-text">Ditt BMI p\u00E5 ' + bmiVal + ' ligger inom normalspannet. BMI s\u00E4ger inget om muskelmassa eller hur du m\u00E5r, men som riktm\u00E4rke ser det bra ut.</p>';
    } else if (bmiVal < 30) {
      html += '<p class="gh-hp-s3__bmi-text">Ditt BMI p\u00E5 ' + bmiVal + ' hamnar i spannet f\u00F6r \u00F6vervikt. Det s\u00E4ger inte allt: muskelmassa och kroppssammans\u00E4ttning spelar stor roll. Men det \u00E4r v\u00E4rt att ha koll p\u00E5.</p>';
    } else if (bmiVal < 35) {
      html += '<p class="gh-hp-s3__bmi-text">Ditt BMI p\u00E5 ' + bmiVal + ' indikerar ett f\u00F6rh\u00F6jt v\u00E4rde. BMI m\u00E4ter inte allt, men i kombination med andra faktorer kan det vara v\u00E4rt att ha koll p\u00E5.</p>';
    } else {
      html += '<div class="gh-hp-s3__disclaimer">Ditt BMI p\u00E5 ' + bmiVal + ' indikerar ett f\u00F6rh\u00F6jt v\u00E4rde. BMI m\u00E4ter inte allt, men i kombination med andra faktorer kan det vara v\u00E4rt att ta det p\u00E5 allvar.</div>';
    }

    /* Disclaimer visas i S5 (makroplanen), ej dubblerad har i S3 */

    /* Diabetes note */
    if (state.diabetes) {
      html += '<p class="gh-hp-s3__diabetes-note">Eftersom du har diabetes har vi tagit h\u00E4nsyn till det i din ber\u00E4kning. Din f\u00F6rdelning av makron\u00E4rings\u00E4mnen anpassas f\u00F6r att ge stabilare blodsocker.</p>';
    }

    interpEl.innerHTML = html;
  }

  /* ── Rendering: S5 Macro cards ── */
  function renderMacroCards() {
    if (!macrosEl || !result) return;

    /* Vid movement.needed: visa S5 initialt med movementResult (inkl. minExercise) */
    var initResult = (movementResult && movementResult.valid) ? movementResult : result;
    var icon = '<span class="gh-hp-tip-icon">' + INFO_ICON + '</span>';
    var macros = initResult.macros;
    var macroTotal = macros.totalKcal;
    var initDiff = macroTotal - initResult.targetCalories;
    var initBudgetOk = (initDiff <= 5);
    var initDisplayKcal = initResult.targetCalories;
    var initLabel = 'Ditt dagliga riktv\u00E4rde';

    /* Dynamisk S5-titel (v4.1) */
    var s5Title = document.getElementById('ghHpS5Title');
    if (s5Title) {
      s5Title.textContent = 'S\u00C5 F\u00D6RDELAR DU DINA ' + initDisplayKcal.toLocaleString('sv-SE') + ' KCAL';
    }

    var html = '';

    /* Movement-notis: fylls dynamiskt av initMovementSliders() om sanity-trigger ar aktiv */
    html += '<div id="ghMovementNotice" class="gh-hp-s5__movement-notice" style="display:none;"></div>';

    /* Kalorimål centralt */
    html += '<div class="gh-hp-s5__kcal-hero"><span class="gh-hp-s5__kcal-value" data-count="' + initDisplayKcal + '">0</span><span class="gh-hp-s5__kcal-unit">kcal / dag</span><span class="gh-hp-s5__kcal-label">' + initLabel + '</span></div>';

    /* Makrokort */
    html += '<div class="gh-hp-s5__macros-grid">';
    html += '<div class="gh-hp-s5__macro-card gh-hp-s5__macro-card--protein"><span class="gh-hp-s5__macro-label" data-tip-label="PROTEIN">PROTEIN ' + icon + '</span><span class="gh-hp-s5__macro-value" data-count="' + macros.protein.grams + '">0</span><span class="gh-hp-s5__macro-suffix">g</span><p class="gh-hp-s5__macro-explain">' + macros.protein.percent + '% av dina kalorier</p></div>';
    html += '<div class="gh-hp-s5__macro-card gh-hp-s5__macro-card--fat"><span class="gh-hp-s5__macro-label" data-tip-label="FETT">FETT ' + icon + '</span><span class="gh-hp-s5__macro-value" data-count="' + macros.fat.grams + '">0</span><span class="gh-hp-s5__macro-suffix">g</span><p class="gh-hp-s5__macro-explain">' + macros.fat.percent + '% av dina kalorier</p></div>';
    html += '<div class="gh-hp-s5__macro-card gh-hp-s5__macro-card--carbs"><span class="gh-hp-s5__macro-label" data-tip-label="KOLHYDRATER">KOLHYDRATER ' + icon + '</span><span class="gh-hp-s5__macro-value" data-count="' + macros.carbs.grams + '">0</span><span class="gh-hp-s5__macro-suffix">g</span><p class="gh-hp-s5__macro-explain">' + macros.carbs.percent + '% av dina kalorier</p></div>';
    html += '</div>';

    /* Forklaring under makrokorten: hur P/F/K beraknas */
    html += '<p id="ghMacroExplainer" class="gh-hp-s5__macro-explainer">Protein och fett anpassas utifr\u00E5n din kropp, \u00E5lder, k\u00F6n och m\u00E5l. N\u00E4r du r\u00F6r dig mer \u00F6kar kaloribudgeten, och det \u00E4r kolhydraterna som f\u00E5r extra utrymme.</p>';

    /* Traffic light legend: visas dynamiskt av updateMacroDisplay */
    html += '<div id="ghMacroLegend" class="gh-hp-s5__macro-legend">';
    html += '<span class="gh-hp-s5__macro-legend-item"><span class="gh-hp-s5__macro-legend-dot gh-hp-s5__macro-legend-dot--yellow"></span><span class="gh-hp-s5__macro-legend-text--yellow">Under minimum</span></span>';
    html += '<span class="gh-hp-s5__macro-legend-item"><span class="gh-hp-s5__macro-legend-dot gh-hp-s5__macro-legend-dot--red"></span><span class="gh-hp-s5__macro-legend-text--red">Kritiskt l\u00E5gt</span></span>';
    html += '</div>';

    /* BTS Level (om diabetes) */
    if (state.diabetes) {
      html += '<div class="gh-hp-s5__bts-card">';
      html += '<span class="gh-hp-s5__macro-label" data-tip-label="BTS LEVEL">BTS LEVEL ' + icon + '</span>';
      html += '<span class="gh-hp-s5__bts-value">1</span>';
      html += '<span class="gh-hp-s5__bts-dots">';
      html += '<span class="gh-hp-s5__bts-dot gh-hp-s5__bts-dot--active"></span>';
      html += '<span class="gh-hp-s5__bts-dot"></span>';
      html += '<span class="gh-hp-s5__bts-dot"></span>';
      html += '</span>';
      html += '<span class="gh-hp-s5__bts-micro">Alla startar p\u00E5 Level 1. Niv\u00E5n justeras av din coach.</span>';
      html += '</div>';
    }

    /* Disclaimer: differentierad vid extrema BMI, klickbar kontaktlank */
    if (result.safeguard && result.safeguard.showDisclaimer) {
      var bmiDisc = result.bmi.value;
      var discText = '';
      if (bmiDisc < 16) {
        discText = 'Ditt BMI tyder p\u00E5 kraftig undervikt. Siffrorna ovan \u00E4r inte en plan att f\u00F6lja p\u00E5 egen hand: <span style="color:#11cfc9;text-decoration:underline;cursor:pointer;" data-contact>h\u00F6r av dig till oss</span> eller kontakta v\u00E5rden innan du g\u00F6r f\u00F6r\u00E4ndringar.';
      } else if (bmiDisc < 18.5) {
        discText = 'Ditt BMI tyder p\u00E5 undervikt. Siffrorna \u00E4r en utg\u00E5ngspunkt: <span style="color:#11cfc9;text-decoration:underline;cursor:pointer;" data-contact>h\u00F6r av dig till oss</span> s\u00E5 tar vi fram en plan som passar just dig.';
      } else {
        discText = 'Vid din kroppsvikt rekommenderar vi att du <span style="color:#11cfc9;text-decoration:underline;cursor:pointer;" data-contact>h\u00F6r av dig till oss</span> s\u00E5 vi kan finjustera din plan personligt.';
      }
      html += '<div class="gh-hp-s5__disclaimer">' + discText + '</div>';
    }

    macrosEl.innerHTML = html;
    initTooltips(macrosEl);
  }

  /* ── Rendering: S5 Movement sliders (v2.5) ── */

  var movementOriginalPal = null;
  var movementOriginalExercise = 0;
  /* SINGLE-FLIGHT MOT EN SERVER UTAN FENCE. `/submit` har ingen versionsgrind, alltså
     är sänd ordning samma som tillämpad BARA med högst en begäran i flykt: annars kan
     två sparningar skrivas i omvänd ordning och ett äldre kvitto bekräfta ett överskrivet
     läge. `okant` håller låset till omladdning (servern kan ha skrivit, nästa begäran har
     ingen fence). Modulbundet, aldrig en DOM-egenskap: `disabled` speglar, bestämmer ej. */
  var rorelseSparLage = 'idle', SPAR_TIDSGRANS_MS = 15000;
  var savedExerciseKcal = 0;  /* Sparad exercise fran server (inloggad) eller localStorage */
  /* Kundens egen PAL-justering, sparad med reglaget nedan (gh_adjusted_pal).
     Sätts BARA av den inloggade laddvägen och nollas när formuläret körs om, så
     ett gammalt reglagevärde aldrig kan följa med in i en ny beräkning.
     null = ingen giltig justering, alltså gäller formulärets vardagsrörelse
     (issue #134, samma läsregel som workern lagrar med). */
  var savedAdjustedPal = null;

  /* N-1-KOMPATIBILITET (extern runda på PR #143, klass K4).
     Temat deployas PER FIL, manuellt och icke-atomiskt (Deploy Theme), så den
     här filen kan gå live medan gh-algorithm.js ännu är föregående version UTAN
     de delade PAL-metoderna. Ett rakt anrop hade då kastat TypeError och tagit
     hela den inloggade laddvägen med sig. Saknas metoderna gäller EXAKT
     beteendet före issue #134: formulärets vardagsrörelse räknas och reglaget
     startar på den. Fallbacken är bakåtkompatibilitet, aldrig en andra sanning. */
  function harDeladPalregel() {
    return typeof GHAlgorithm !== 'undefined' && !!GHAlgorithm
      && typeof GHAlgorithm.giltigtPal === 'function'
      && typeof GHAlgorithm.effektivtPal === 'function';
  }

  /**
   * Valj basta exercise-exemplet for visning i notice/copy.
   * Regel: max 60 min. Forst vardaglig (MET <= 6), sedan narmast 35 min.
   * Fallback: kortast tid oavsett.
   */
  function pickBestExample(examples) {
    if (!examples || examples.length == 0) return null;
    var best = null;
    var bestScore = 999;

    /* Pass 1: max 60 min + vardaglig (MET <= 6), narmast 35 min */
    for (var i = 0; i < examples.length; i++) {
      if (examples[i].minutes <= 60 && examples[i].met <= 6) {
        var sc = Math.abs(examples[i].minutes - 35);
        if (sc < bestScore) { best = examples[i]; bestScore = sc; }
      }
    }
    if (best) return best;

    /* Pass 2: max 60 min, lagst MET (mest vardaglig) */
    for (var j = 0; j < examples.length; j++) {
      if (examples[j].minutes <= 60) {
        if (!best || examples[j].met < best.met) {
          best = examples[j];
        }
      }
    }
    if (best) return best;

    /* Pass 3: kortast tid (inga under 60 min finns) */
    best = examples[0];
    for (var k = 1; k < examples.length; k++) {
      if (examples[k].minutes < best.minutes) best = examples[k];
    }
    return best;
  }

  function renderMovementSliders() {
    if (!macrosEl || !result || !state.weight) return;

    /* Reglaget visar det PAL korten faktiskt räknades på: kundens sparade
       justering före formulärets vardagsrörelse. Utan det stod reglaget på 3
       medan makrokorten visade siffrorna för 7. giltigtPal returnerar aldrig 0,
       så kedjan kan använda ||. */
    var palVal = savedAdjustedPal || state.activity || 3;
    var exVal = savedExerciseKcal || 0;
    movementOriginalPal = palVal;
    movementOriginalExercise = exVal;

    var palLabels = GHAlgorithm.PAL_LABELS || {};
    var palLabel = palLabels[palVal] || '';
    var icon = '<span class="gh-hp-tip-icon">' + INFO_ICON + '</span>';

    var html = '<div class="gh-hp-s5__movement">';
    html += '<div class="gh-hp-s5__movement-header">';
    html += '<h3>HUR MYCKET R\u00D6R DU DIG?</h3>';
    html += '<p class="gh-hp-s5__movement-intro">Sm\u00E5 vanor g\u00F6r stor skillnad. Dra i reglagen och se hur din vardag och tr\u00E4ning p\u00E5verkar vad du beh\u00F6ver \u00E4ta i realtid. Kanske r\u00E4cker det med en kort promenad f\u00F6r att f\u00F6r\u00E4ndra allt.</p>';
    html += '</div>';

    /* PAL Slider */
    html += '<div class="gh-hp-s5__slider-group">';
    html += '<label class="gh-hp-s5__slider-label" data-tip-label="VARDAGSR\u00D6RELSE">VARDAGSR\u00D6RELSE ' + icon + '</label>';
    html += '<input type="range" id="ghMovementPal" min="1" max="10" step="1" value="' + palVal + '" class="gh-hp-s5__slider gh-hp-s5__slider--pal">';
    html += '<div class="gh-hp-s5__slider-display">';
    html += '<span><span id="ghPalValue">' + palVal + '</span>/10</span>';
    html += '<span id="ghPalLabel">' + palLabel + '</span>';
    html += '</div>';
    html += '</div>';

    /* Traning Slider */
    html += '<div class="gh-hp-s5__slider-group">';
    html += '<label class="gh-hp-s5__slider-label" data-tip-label="TR\u00C4NING">TR\u00C4NING ' + icon + '</label>';
    html += '<input type="range" id="ghMovementExercise" min="0" max="1000" step="50" value="' + exVal + '" class="gh-hp-s5__slider gh-hp-s5__slider--exercise">';
    html += '<div class="gh-hp-s5__slider-display">';
    html += '<span id="ghExerciseValue">' + exVal + '</span> kcal/dag';
    html += '</div>';
    html += '</div>';

    /* Samlad forklaringstext (ersatter separata exercise-examples + movement-info) */
    html += '<div id="ghMovementInfo" class="gh-hp-s5__movement-info">';
    html += 'Prova att dra i tr\u00E4ningsreglaget. Du kommer se att det inte kr\u00E4vs s\u00E5 mycket som du tror, och att varje liten \u00F6kning g\u00F6r verklig skillnad f\u00F6r vad din kropp kan g\u00F6ra med maten.';
    html += '</div>';

    /* Spara-knapp */
    html += '<div class="gh-hp-s5__movement-save-wrap" style="text-align:center">';
    html += '<button id="ghMovementSave" class="gh-hp-s5__movement-save" style="display:none;">SPARA \u00C4NDRINGAR</button>';
    html += '<span id="ghMovementSaved" class="gh-hp-s5__movement-saved" style="display:none;">Sparat</span>';
    html += '<span id="ghMovementSaveError" class="gh-hp-s5__movement-saved" style="display:none;color:#ff4d4d;"></span>';
    html += '</div>';

    html += '</div>';

    macrosEl.insertAdjacentHTML('beforeend', html);
    initTooltips(macrosEl.querySelector('.gh-hp-s5__movement'));
  }

  function initMovementSliders() {
    var palSlider = document.getElementById('ghMovementPal');
    var exSlider = document.getElementById('ghMovementExercise');
    if (!palSlider || !exSlider) return;

    /* Bestam startvarde: sparat > minExercise > 0 */
    var startEx = savedExerciseKcal || 0;
    if (startEx == 0 && minExerciseKcal > 0) {
      startEx = minExerciseKcal;
    }

    if (startEx > 0) {
      exSlider.value = startEx;
      movementOriginalExercise = startEx;

      /* Movement-notice i S5 (visa om minExercise triggats OCH inget sparat varde finns) */
      if (minExerciseKcal > 0 && !savedExerciseKcal) {
        var noticeEl = document.getElementById('ghMovementNotice');
        if (noticeEl) {
          var examples = GHAlgorithm.getExerciseExamples(minExerciseKcal, state.weight, state.goal);
          var bestEx = pickBestExample(examples);
          var noticeHtml = 'Inkluderar <strong>' + minExerciseKcal + ' kcal daglig r\u00F6relse</strong>';
          if (bestEx) {
            noticeHtml += ' (ex. ' + bestEx.minutes + ' min ' + bestEx.label.toLowerCase() + ')';
          }
          noticeHtml += '. Justera fritt nedan.';
          noticeEl.innerHTML = noticeHtml;
          noticeEl.style.display = '';
        }
      }

      /* Omberakna med startvarde */
      onSliderChange();
    }

    /* Event handlers */
    palSlider.addEventListener('input', onSliderChange);
    exSlider.addEventListener('input', onSliderChange);

    /* Spara-knapp */
    var saveBtn = document.getElementById('ghMovementSave');
    if (saveBtn) {
      saveBtn.addEventListener('click', function() {
        saveMovementData();
      });
    }
  }

  function onSliderChange() {
    var palSlider = document.getElementById('ghMovementPal');
    var exSlider = document.getElementById('ghMovementExercise');
    if (!palSlider || !exSlider) return;

    var newPal = parseInt(palSlider.value);
    var newExercise = parseInt(exSlider.value);

    /* Uppdatera PAL label */
    var palValEl = document.getElementById('ghPalValue');
    var palLabelEl = document.getElementById('ghPalLabel');
    var palLabels = GHAlgorithm.PAL_LABELS || {};
    if (palValEl) palValEl.textContent = newPal;
    if (palLabelEl) palLabelEl.textContent = palLabels[newPal] || '';

    /* Uppdatera exercise display */
    var exValEl = document.getElementById('ghExerciseValue');
    if (exValEl) exValEl.textContent = newExercise;

    /* Omberakna med nya varden */
    var newResult = GHAlgorithm.calculate({
      gender: state.gender,
      age: state.age,
      weight: state.weight,
      height: state.height,
      activityLevel: newPal,
      goal: state.goal,
      algorithm: state.diabetes ? 'BTS' : 'MTH',
      btsLevel: 1,
      hasDiabetes: state.diabetes,
      exerciseKcal: newExercise
    });

    if (!newResult || !newResult.valid) return;

    /* Uppdatera UI: ENBART S5, aldrig S3 */
    updateMacroDisplay(newResult);
    updateMovementInfo(newResult, newPal, newExercise);

    /* Dynamisk varning: makros > budget */
    updateMovementWarning(newResult);

    /* Visa spara-knapp om andrat fran original */
    var changed = (newPal != movementOriginalPal || newExercise != movementOriginalExercise);
    var saveBtn = document.getElementById('ghMovementSave');
    if (saveBtn) saveBtn.style.display = changed ? '' : 'none';
  }

  function updateMovementWarning(calcResult) {
    var warningEl = document.getElementById('ghMovementWarning');
    if (!warningEl) {
      /* Skapa varnings-elementet dynamiskt vid forsta behovet */
      var container = document.querySelector('.gh-hp-s5__movement');
      if (!container) return;
      warningEl = document.createElement('div');
      warningEl.id = 'ghMovementWarning';
      warningEl.className = 'gh-hp-s5__movement-warning';
      warningEl.style.display = 'none';
      container.appendChild(warningEl);
    }

    if (!calcResult || !calcResult.macros) { warningEl.style.display = 'none'; return; }

    var rawKkcal = Math.max(0, calcResult.targetCalories - (calcResult.macros.protein.grams * 4) - (calcResult.macros.fat.grams * 9));
    var rawK = Math.round(rawKkcal / 4);
    if (rawK < 130) {
      /* PAL FÖR VARNINGEN ÄR DET PAL VARNINGEN GÄLLER (issue #134). Raden sökte
         DOM-id:t ghPalSlider, som inte finns någonstans i temat: reglaget heter
         ghMovementPal. Uppslaget gav alltid null, alltså föll uträkningen alltid
         till state.activity (formulärets RÅA vardagsrörelse) medan calcResult
         ovan räknades på reglagets nivå. Den rekommenderade minsta rörelsen
         beskrev därför en annan aktivitetsnivå än varningen den står i, och
         kundens sparade justering syntes aldrig.
         Finns inget reglage (varningen kan visas innan movement-blocket byggts)
         gäller kundens EFFEKTIVA PAL via den delade regeln, aldrig råvärdet;
         i N-1-läget (gh-algorithm.js ännu utan regeln) står råvärdet kvar. */
      var palEl = document.getElementById('ghMovementPal');
      var deladPalregel = harDeladPalregel();
      var palForVarning = palEl ? parseInt(palEl.value)
        : (deladPalregel ? GHAlgorithm.effektivtPal(savedAdjustedPal, state.activity) : state.activity);
      var minEx = GHAlgorithm.calculateMinExercise(
        state.gender, parseInt(state.age), parseFloat(state.weight), parseFloat(state.height),
        parseInt(palForVarning),
        state.goal, state.diabetes ? 'BTS' : 'MTH', 1
      );
      var html = '<strong>Vi rekommenderar inte det h\u00E4r.</strong> ';
      html += 'P\u00E5 ' + calcResult.targetCalories.toLocaleString('sv-SE') + ' kcal f\u00E5r du bara ' + rawK + 'g kolhydrater, ';
      if (rawK < 50) {
        html += 'l\u00E5ngt under vad hj\u00E4rnan beh\u00F6ver f\u00F6r att fungera. ';
      } else if (rawK < 100) {
        html += 'under h\u00E4lften av vad kroppen beh\u00F6ver. ';
      } else {
        html += 'under gr\u00E4nsen f\u00F6r vad vi anser s\u00E4kert. ';
      }
      html += 'Du har tv\u00E5 val: ';
      if (minEx !== null) {
        var examples = GHAlgorithm.getExerciseExamples(minEx, state.weight, state.goal);
        var bestEx = pickBestExample(examples);
        html += 'L\u00E4gg till r\u00F6relse. ';
        if (bestEx) {
          html += 'Ex. <strong>' + bestEx.minutes + ' min ' + bestEx.label.toLowerCase() + '</strong> per dag r\u00E4cker';
        } else {
          html += 'Minst ' + minEx + ' kcal tr\u00E4ning per dag';
        }
        html += ', s\u00E5 f\u00E5r du i dig det du beh\u00F6ver och n\u00E5r ditt m\u00E5l. ';
      }
      if (state.goal == 'G\u00E5 ner i vikt') {
        html += 'Eller beh\u00E5ll n\u00E4ringen och acceptera att fettminskningen g\u00E5r l\u00E5ngsammare.';
      } else if (state.goal == 'Bygga muskler') {
        html += 'Eller beh\u00E5ll n\u00E4ringen och justera tr\u00E4ningsuppl\u00E4gget ist\u00E4llet.';
      } else {
        html += 'Eller beh\u00E5ll n\u00E4ringen och anpassa din plan.';
      }
      warningEl.innerHTML = html;
      warningEl.style.display = '';
    } else {
      warningEl.style.display = 'none';
    }
  }

  function updateMacroDisplay(newResult) {
    if (!newResult || !newResult.macros) return;
    var m = newResult.macros;
    var target = newResult.targetCalories;
    var macroTotal = m.totalKcal;
    var diff = macroTotal - target;
    var budgetOk = (diff <= 5);

    /* Berakna ra-makros utan golv: vad som FAKTISKT ryms i target */
    var rawP = m.protein.grams;
    var rawF = m.fat.grams;
    var rawKkcal = Math.max(0, target - (rawP * 4) - (rawF * 9));
    var rawK = Math.round(rawKkcal / 4);

    var showP = budgetOk ? m.protein.grams : rawP;
    var showF = budgetOk ? m.fat.grams : rawF;
    var showK = budgetOk ? m.carbs.grams : rawK;

    /* Kcal hero: visar alltid target (det ar malet) */
    var kcalHero = document.querySelector('.gh-hp-s5__kcal-value');
    if (kcalHero) {
      kcalHero.textContent = target;
      kcalHero.setAttribute('data-count', target);
    }

    /* S5 titel */
    var s5Title = document.getElementById('ghHpS5Title');
    if (s5Title) {
      s5Title.textContent = 'S\u00C5 F\u00D6RDELAR DU DINA ' + target.toLocaleString('sv-SE') + ' KCAL';
    }

    /* Kcal label */
    var kcalLabel = document.querySelector('.gh-hp-s5__kcal-label');
    if (kcalLabel) {
      kcalLabel.textContent = 'Ditt dagliga riktv\u00E4rde';
    }

    /* Traffic light: bara kolhydrater om faktiskt under 130g */
    var macroCardEls = macrosEl.querySelectorAll('.gh-hp-s5__macro-card');
    for (var c = 0; c < macroCardEls.length; c++) {
      macroCardEls[c].setAttribute('data-status', 'ok');
    }
    var carbsCardEl = macrosEl.querySelector('.gh-hp-s5__macro-card--carbs');
    if (carbsCardEl && !budgetOk && showK < 130) {
      carbsCardEl.setAttribute('data-status', 'warn');
    }

    /* Macro cards: fade ut, uppdatera, fade in */
    var cards = macrosEl.querySelectorAll('.gh-hp-s5__macro-value');
    for (var i = 0; i < cards.length; i++) {
      cards[i].style.transition = 'opacity 0.15s';
      cards[i].style.opacity = '0.3';
    }

    setTimeout(function() {
      var pEl = macrosEl.querySelector('.gh-hp-s5__macro-card--protein .gh-hp-s5__macro-value');
      if (pEl) { pEl.textContent = showP; pEl.setAttribute('data-count', showP); }

      var fEl = macrosEl.querySelector('.gh-hp-s5__macro-card--fat .gh-hp-s5__macro-value');
      if (fEl) { fEl.textContent = showF; fEl.setAttribute('data-count', showF); }

      var kEl = macrosEl.querySelector('.gh-hp-s5__macro-card--carbs .gh-hp-s5__macro-value');
      if (kEl) {
        kEl.textContent = showK;
        kEl.setAttribute('data-count', showK);
        /* Traffic light: kolhydrater far farg efter status */
        if (!budgetOk && showK < 50) {
          kEl.style.color = '#c62828';
        } else if (!budgetOk && showK < 130) {
          kEl.style.color = '#f2a62a';
        } else {
          kEl.style.color = '';
        }
      }
      /* Suffix (g) fargkodas med */
      var kSuffix = macrosEl.querySelector('.gh-hp-s5__macro-card--carbs .gh-hp-s5__macro-suffix');
      if (kSuffix) {
        if (!budgetOk && showK < 50) {
          kSuffix.style.color = '#c62828';
        } else if (!budgetOk && showK < 130) {
          kSuffix.style.color = '#f2a62a';
        } else {
          kSuffix.style.color = '';
        }
      }

      /* Uppdatera procent mot target */
      var pctBase = target;
      if (pctBase <= 0) pctBase = 1;
      var pPct = Math.round((showP * 4 / pctBase) * 100);
      var fPct = Math.round((showF * 9 / pctBase) * 100);
      var kPct = 100 - pPct - fPct;
      if (kPct < 0) kPct = 0;

      var pExpl = macrosEl.querySelector('.gh-hp-s5__macro-card--protein .gh-hp-s5__macro-explain');
      if (pExpl) pExpl.textContent = pPct + '% av dina kalorier';

      var fExpl = macrosEl.querySelector('.gh-hp-s5__macro-card--fat .gh-hp-s5__macro-explain');
      if (fExpl) fExpl.textContent = fPct + '% av dina kalorier';

      var kExpl = macrosEl.querySelector('.gh-hp-s5__macro-card--carbs .gh-hp-s5__macro-explain');
      if (kExpl) kExpl.textContent = kPct + '% av dina kalorier';

      /* Fade in */
      for (var i = 0; i < cards.length; i++) {
        cards[i].style.opacity = '1';
      }

      /* Traffic light legend: bara om nagon makro faktiskt ar fargad */
      var legendEl = document.getElementById('ghMacroLegend');
      if (legendEl) {
        var hasColoredValue = !budgetOk && showK < 130;
        legendEl.className = hasColoredValue ? 'gh-hp-s5__macro-legend gh-hp-s5__macro-legend--visible' : 'gh-hp-s5__macro-legend';
      }
    }, 150);
  }

  function updateTargetCaloriesDisplay(newResult) {
    /* S3 highlight card (malkalorier) */
    var highlightValue = document.querySelector('.gh-hp-s3__card--highlight .gh-hp-s3__card-value');
    if (highlightValue) {
      highlightValue.style.transition = 'opacity 0.15s';
      highlightValue.style.opacity = '0.3';
      setTimeout(function() {
        highlightValue.textContent = newResult.targetCalories;
        highlightValue.style.opacity = '1';
      }, 150);
    }
  }

  function updateInterpretationText(newResult, newExercise) {
    if (!interpEl || !newResult) return;

    var bmr = result.bmr;
    var baseTdee = result.tdee;
    var newTarget = newResult.targetCalories;

    /* Smooth fade-transition pa S3-text + subtitle */
    interpEl.style.transition = 'opacity 0.25s';
    interpEl.style.opacity = '0.3';
    var subtitleEl = document.getElementById('ghHpS3Subtitle');
    if (subtitleEl) {
      subtitleEl.style.transition = 'opacity 0.25s';
      subtitleEl.style.opacity = '0.3';
    }

    setTimeout(function() {

    /* Uppdatera subtitle beroende pa exercise */
    if (subtitleEl) {
      if (newExercise > 0) {
        subtitleEl.textContent = 'Din kropp, din vardag och lite daglig r\u00F6relse. Tillsammans ger de din kaloribudget.';
      } else {
        subtitleEl.textContent = 'S\u00E5 h\u00E4r jobbar din kropp just nu, varje dag, oavsett om du tr\u00E4nar eller inte.';
      }
      subtitleEl.style.opacity = '1';
    }

    /* Spara BMI- och diabetes-notiser innan vi skriver over */
    var bmiText = interpEl.querySelector('.gh-hp-s3__bmi-text, .gh-hp-s3__disclaimer');
    var diabetesNote = interpEl.querySelector('.gh-hp-s3__diabetes-note');
    var bmiHtml = bmiText ? bmiText.outerHTML : '';
    var diabetesHtml = diabetesNote ? diabetesNote.outerHTML : '';

    var html = '';
    html += '<p class="gh-hp-s3__interp-text">';
    html += 'Din kropp f\u00F6rbr\u00E4nner ' + bmr.toLocaleString('sv-SE') + ' kcal i vila och ' + baseTdee.toLocaleString('sv-SE') + ' kcal totalt med din vardag.';
    html += '</p>';

    if (newExercise > 0) {
      /* Movement-justerad text */
      var effectiveTDEE = newResult.movement ? newResult.movement.effectiveTDEE : baseTdee;

      /* Konkret traning-exempel (max 60 min, vardaglig forst) */
      var exExamples = GHAlgorithm.getExerciseExamples(newExercise, state.weight, state.goal);
      var exampleStr = '';
      var bestS3 = pickBestExample(exExamples);
      if (bestS3) {
        exampleStr = ' (ex. ' + bestS3.minutes + ' min ' + bestS3.label.toLowerCase() + ')';
      }

      html += '<p class="gh-hp-s3__interp-text">';
      html += 'Med <strong>' + newExercise + ' kcal daglig r\u00F6relse</strong>' + exampleStr + ' h\u00F6js din totalf\u00F6rbr\u00E4nning till ' + effectiveTDEE.toLocaleString('sv-SE') + ' kcal. ';

      if (state.goal == 'G\u00E5 ner i vikt') {
        var deficit = effectiveTDEE - newTarget;
        html += 'Med det och ett underskott p\u00E5 ' + deficit.toLocaleString('sv-SE') + ' kcal blir ditt riktv\u00E4rde <strong>' + newTarget.toLocaleString('sv-SE') + ' kcal per dag</strong>.';
      } else if (state.goal == 'Bygga muskler') {
        var surplus = newTarget - effectiveTDEE;
        html += 'Med det och ett p\u00E5slag p\u00E5 ' + surplus.toLocaleString('sv-SE') + ' kcal blir ditt riktv\u00E4rde <strong>' + newTarget.toLocaleString('sv-SE') + ' kcal per dag</strong>.';
      } else {
        html += 'Ditt riktv\u00E4rde landar p\u00E5 <strong>' + newTarget.toLocaleString('sv-SE') + ' kcal per dag</strong>.';
      }
    } else {
      /* Utan movement */
      if (state.goal == 'G\u00E5 ner i vikt') {
        var deficit = baseTdee - newTarget;
        html += 'Ett underskott p\u00E5 ' + deficit.toLocaleString('sv-SE') + ' kcal ger kontrollerad fettminskning utan att kroppen bromsar in. ';
        html += 'Ditt riktv\u00E4rde: <strong>' + newTarget.toLocaleString('sv-SE') + ' kcal/dag</strong>.';
      } else if (state.goal == 'Bygga muskler') {
        var surplus = newTarget - baseTdee;
        html += 'Ett \u00F6verskott p\u00E5 ' + surplus.toLocaleString('sv-SE') + ' kcal ger kroppen byggmaterial. Utan tr\u00E4ning lagras det som fett: regelbunden styrketr\u00E4ning g\u00F6r skillnaden. ';
        html += 'Ditt riktv\u00E4rde: <strong>' + newTarget.toLocaleString('sv-SE') + ' kcal/dag</strong>.';
      } else {
        html += 'Du siktar p\u00E5 att forma kroppen. Ditt riktv\u00E4rde: ';
        html += '<strong>' + baseTdee.toLocaleString('sv-SE') + ' kcal/dag</strong>.';
      }
    }
    html += '</p>';

    html += bmiHtml;
    html += diabetesHtml;

    interpEl.innerHTML = html;
    interpEl.style.opacity = '1';

    }, 250); /* Stang setTimeout fran fade-ut */
  }

  function updateMovementInfo(newResult, newPal, newExercise) {
    var infoEl = document.getElementById('ghMovementInfo');
    if (!infoEl) return;

    if (newExercise > 0) {
      var examples = GHAlgorithm.getExerciseExamples(newExercise, state.weight, state.goal);
      var html = '';

      /* Huvudtext: separera TDEE fran malkcal */
      var effTDEE = newResult.movement ? newResult.movement.effectiveTDEE : newResult.tdee;
      html += 'Din totala f\u00F6rbr\u00E4nning med tr\u00E4ningen blir ' + effTDEE.toLocaleString('sv-SE') + ' kcal. ';
      if (state.goal == 'G\u00E5 ner i vikt') {
        html += 'D\u00E4rf\u00F6r hamnar ditt m\u00E5l p\u00E5 <strong>' + newResult.targetCalories.toLocaleString('sv-SE') + ' kcal</strong>: det underskottet beh\u00F6vs f\u00F6r att g\u00E5 ner. ';
      } else if (state.goal == 'Bygga muskler') {
        html += 'Ditt m\u00E5l hamnar p\u00E5 <strong>' + newResult.targetCalories.toLocaleString('sv-SE') + ' kcal</strong>. Tr\u00E4ningen \u00E4r avg\u00F6rande: utan den blir \u00F6verskottet fett ist\u00E4llet f\u00F6r muskler. ';
      } else {
        html += 'Ditt m\u00E5l: <strong>' + newResult.targetCalories.toLocaleString('sv-SE') + ' kcal per dag</strong>. ';
      }

      /* Konkreta exempel: vardaglig aktivitet forst */
      if (examples && examples.length > 0) {
        html += newExercise + ' kcal motsvarar ungef\u00E4r ';
        var exParts = [];
        for (var i = 0; i < Math.min(examples.length, 3); i++) {
          exParts.push('<strong>' + examples[i].minutes + ' min ' + examples[i].label.toLowerCase() + '</strong>');
        }
        html += exParts.join(', eller ') + '. ';
      }

      html += 'Det beh\u00F6ver inte vara mer \u00E4n s\u00E5. Det viktiga \u00E4r att det blir en vana.';
      infoEl.innerHTML = html;

    /* "Har ändrats" mäts mot det reglaget STOD PÅ när vyn ritades, inte mot
       formulärets vardagsrörelse: efter #134 startar reglaget på kundens sparade
       justering, och en jämförelse mot state.activity hade påstått en ändring
       kunden inte gjort i den här sessionen. */
    } else if (newPal != (movementOriginalPal || state.activity || 3)) {
      infoEl.innerHTML = 'Din vardagsr\u00F6relse har \u00E4ndrats. N\u00E4ringsv\u00E4rdena ovan \u00E4r uppdaterade: de speglar nu din nya vardag.';
    } else {
      if (state.goal == 'Bygga muskler') {
        infoEl.innerHTML = 'F\u00F6r att bygga muskler r\u00E4cker det inte med mat: kroppen beh\u00F6ver tr\u00E4ning f\u00F6r att omvandla \u00F6verskottet till muskelmassa. Dra i reglaget och se hur tr\u00E4ning p\u00E5verkar din plan.';
      } else if (state.goal == 'G\u00E5 ner i vikt') {
        infoEl.innerHTML = 'R\u00F6relse \u00F6kar din f\u00F6rbr\u00E4nning och ger dig mer utrymme i matbudgeten utan att bromsa fettminskningen. Dra i reglaget och se hur lite som kr\u00E4vs.';
      } else {
        infoEl.innerHTML = 'Prova att dra i tr\u00E4ningsreglaget. Du kommer se att det inte kr\u00E4vs s\u00E5 mycket som du tror, och att varje liten \u00F6kning g\u00F6r verklig skillnad f\u00F6r vad din kropp kan g\u00F6ra med maten.';
      }
    }
  }

  function saveMovementData() {
    if (rorelseSparLage !== 'idle') return;
    var palSlider = document.getElementById('ghMovementPal');
    var exSlider = document.getElementById('ghMovementExercise');
    if (!palSlider || !exSlider) return;

    var newPal = parseInt(palSlider.value);
    var newExercise = parseInt(exSlider.value);

    /* Spara till server: bara inloggad kund, /submit är en medlemsväg (#32).
       Kroppen bär ingen adress: identiteten kommer ur App Proxyns signatur. */
    if (customerEmail) {
      satRorelseLage('inflykt');
      var avbryt = (typeof AbortController === 'function') ? new AbortController() : null, timer = null;
      /* KROPPSLÄSNINGEN LIGGER INNE I RACET och sidoeffekterna EFTER det: annars settlar
         racet vid svarshuvudet, och ett svar efter taket hade fått röra vyn. */
      var tak = new Promise(function(_, avvisa) {
        timer = setTimeout(function() {
          if (avbryt) avbryt.abort();
          avvisa(new Error('save_unknown'));
        }, SPAR_TIDSGRANS_MS);
      });
      Promise.race([fetch(API_URL + '/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        signal: avbryt ? avbryt.signal : undefined,
        body: JSON.stringify({ fields: { gh_exercise_kcal: newExercise, gh_adjusted_pal: newPal } })
      })
      .then(function(res) {
        /* BESTÄMT AVSLAG BARA för det workern bevisligen svarar FÖRE sin första skrivning:
           400 och 404. 422, 429 och 5xx kan komma EFTER den, alltså OKÄNT, och ett positivt
           utfall kräver 2xx MED success:true (BP-012, samma som gh-admin/gh-my-habits.js). */
        if (!res.ok) {
          /* 409 är ett BEVISAT nej UTAN skrivning: någon annan flik hann före, och
             handlingen är att läsa om, aldrig att försöka igen mot gamla siffror. */
          throw new Error(res.status === 409 ? 'save_stale'
            : (res.status === 400 || res.status === 404 ? 'save_rejected' : 'save_unknown'));
        }
        return res.json().then(function(data) {
          if (!data || data.success !== true) throw new Error('save_unknown');
        }, function() {
          throw new Error('save_unknown');
        });
      }, function() {
        throw new Error('save_unknown');
      }), tak])
      .then(function() {
        clearTimeout(timer);
        bekraftaRorelse(newPal, newExercise);
        satRorelseLage('idle');
      })
      .catch(function(err) {
        clearTimeout(timer);
        /* BEVISAT NEJ släpper låset: 400 och 404 kommer före serverns första skrivning,
           alltså står den orörd. ALLT OKÄNT håller det till omladdning. Varken
           localStorage eller originalvärdena rörs. */
        var avvisad = err && err.message === 'save_rejected';
        var foraldrad = err && err.message === 'save_stale';
        satRorelseLage(avvisad ? 'idle' : 'okant');
        console.error('[GH] saveMovementData: ' + (err && err.message));
        visaRorelseFel(avvisad
          ? 'Vi kunde inte spara ändringen. Kontrollera dina uppgifter och försök igen.'
          : foraldrad
            ? 'Din profil ändrades i ett annat fönster. Ladda om sidan.'
            : 'Vi kunde inte bekräfta att ändringen sparades. Ladda om sidan för att se aktuellt läge.');
      });
    } else {
      /* Utan inloggning finns ingen server att kvittera mot: localStorage ÄR lagret. */
      console.warn('[GH] saveMovementData: ingen inloggning, sparar bara lokalt');
      bekraftaRorelse(newPal, newExercise);
    }
  }

  /* Läget bestämmer, knappen speglar. `okant` släpps aldrig utan omladdning. */
  function satRorelseLage(lage) {
    rorelseSparLage = lage;
    var saveBtn = document.getElementById('ghMovementSave');
    if (saveBtn) saveBtn.disabled = (lage !== 'idle');
  }

  /* Bekräftelsen sitter EFTER det lästa kvittot, aldrig bredvid anropet. */
  function bekraftaRorelse(newPal, newExercise) {
    var saved = loadFromLocalStorage();
    if (saved) {
      saved.adjustedPAL = newPal;
      saved.exerciseKcal = newExercise;
      saved.ts = Date.now();
      try {
        localStorage.setItem(LS_KEY, JSON.stringify(saved));
      } catch (e) { /* quota */ }
    }

    /* Uppdatera original-varden sa spara-knappen doljs */
    movementOriginalPal = newPal;
    movementOriginalExercise = newExercise;

    /* KVITTOT GÄLLER DE SKICKADE VÄRDENA: drar kunden vidare medan svaret är i luften
       är den nivån OSPARAD, alltså bekräftas ingenting (samma dom som syskonet). */
    var pal = document.getElementById('ghMovementPal'), ex = document.getElementById('ghMovementExercise');
    var kvitteratLage = !!pal && !!ex && parseInt(pal.value) === newPal && parseInt(ex.value) === newExercise;

    var saveBtn = document.getElementById('ghMovementSave');
    if (saveBtn) saveBtn.style.display = kvitteratLage ? 'none' : '';
    var felEl = document.getElementById('ghMovementSaveError');
    if (felEl) felEl.style.display = 'none';
    var savedEl = document.getElementById('ghMovementSaved');
    if (savedEl) {
      savedEl.style.display = kvitteratLage ? '' : 'none';
      if (kvitteratLage) setTimeout(function() { savedEl.style.display = 'none'; }, 2000);
    }
  }

  /* Egen ruta, husets form: "Sparat" bär aldrig en feltext. */
  function visaRorelseFel(text) {
    var savedEl = document.getElementById('ghMovementSaved'), felEl = document.getElementById('ghMovementSaveError');
    if (savedEl) savedEl.style.display = 'none';
    if (felEl) { felEl.textContent = text; felEl.style.display = ''; }
  }

  /* ── Rendering: S6 Dynamic copy (v4.1, 4 varianter) ── */
  function renderNextStep() {
    var s6Title = document.getElementById('ghHpS6Title');
    var s6Body = document.getElementById('ghHpS6Body');
    if (!s6Title || !s6Body) return;

    if (state.diabetes) {
      s6Title.innerHTML = 'DU HAR SIFFRORNA.<br>NU BEH\u00D6VER DU PLANEN.';
      s6Body.textContent = 'Med diabetes \u00E4r det extra viktigt att varje m\u00E5ltid jobbar med din kropp, inte mot den. Vi hj\u00E4lper dig bygga vanor som ger stabilt blodsocker, steg f\u00F6r steg.';
    } else if (state.goal == 'G\u00E5 ner i vikt') {
      s6Title.innerHTML = 'NU VET DU.<br>FR\u00C5GAN \u00C4R VAD DU<br>G\u00D6R MED DET.';
      s6Body.textContent = 'Du har din profil och dina siffror. Skillnaden mellan att veta och att g\u00F6ra ligger i vanorna. Vi hj\u00E4lper dig minska fett, utan dramatik, utan dieter.';
    } else if (state.goal == 'Bygga muskler') {
      s6Title.innerHTML = 'R\u00C4TT BR\u00C4NSLE.<br>R\u00C4TT VANOR.<br>R\u00C4TT RESULTAT.';
      s6Body.textContent = 'Att bygga muskler handlar om mer \u00E4n att tr\u00E4na h\u00E5rt. Det handlar om att ge kroppen r\u00E4tt f\u00F6ruts\u00E4ttningar, varje dag, inte bara p\u00E5 gymmet.';
    } else {
      /* Forma kroppen */
      s6Title.innerHTML = 'ATT FORMA KROPPEN<br>\u00C4R OCKS\u00C5 ETT M\u00C5L.';
      s6Body.textContent = 'Du vet vad din kropp beh\u00F6ver. Nu handlar det om att g\u00F6ra det till en vana, inte ett projekt. Vi hj\u00E4lper dig forma kroppen utan att det tar \u00F6ver vardagen.';
    }
  }

  /* ── CountUp animation ── */
  function countUp(el, target, duration, decimals) {
    var motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (motionQuery && motionQuery.matches) {
      el.textContent = decimals ? target.toFixed(decimals) : Math.round(target);
      return;
    }

    var start = 0;
    var startTime = null;
    duration = duration || 1200;

    function easeOutCubic(t) {
      return 1 - Math.pow(1 - t, 3);
    }

    function frame(timestamp) {
      if (!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);
      var easedProgress = easeOutCubic(progress);
      var current = start + (target - start) * easedProgress;

      if (decimals) {
        el.textContent = current.toFixed(decimals);
      } else {
        el.textContent = Math.round(current);
      }

      if (progress < 1) {
        requestAnimationFrame(frame);
      }
    }

    requestAnimationFrame(frame);
  }

  function observeCountUp(container) {
    if (!window.IntersectionObserver) {
      triggerCountUp(container);
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          triggerCountUp(container);
          observer.disconnect();
          break;
        }
      }
    }, { threshold: 0.2 });

    observer.observe(container);
  }

  function triggerCountUp(container) {
    var els = container.querySelectorAll('[data-count]');
    for (var i = 0; i < els.length; i++) {
      (function(el, delay) {
        var target = parseFloat(el.getAttribute('data-count'));
        var decimals = parseInt(el.getAttribute('data-decimals')) || 0;
        setTimeout(function() {
          countUp(el, target, 1200, decimals);
        }, delay);
      })(els[i], i * 120);
    }
  }

  /* ── Email gate ── */
  /* 'idle' | 'inflight' | 'unknown'. Delas av knappen och Enter-vägen. */
  var baselineState = 'idle';

  function handleEmailSubmit() {
    if (!emailInput || !emailBtn) return;

    /* IN-FLIGHT-GUARD I INGÅNGEN, samma mönster som My Habits mhMutationState.
       Knappens disabled låser bara KNAPPEN: Enter-lyssnaren på e-postfältet
       anropar samma funktion direkt, så en kund som tryckte Enter igen medan
       anropet var i luften startade en andra inskickning. Och efter ett ovisst
       utfall står knappen kvar låst med flit; utan den här grinden var Enter en
       väg runt just det låset. */
    if (baselineState !== 'idle') {
      emailError.textContent = baselineState === 'unknown'
        ? 'Ladda om sidan innan du skickar igen. Vi vet inte om den förra inskickningen gick igenom.'
        : 'V\u00E4nta, din profil skickas redan.';
      emailError.style.display = 'block';
      return;
    }

    var firstName = firstNameInput ? firstNameInput.value.trim() : '';
    var lastName = lastNameInput ? lastNameInput.value.trim() : '';
    var email = emailInput.value.trim();

    if (!email || email.indexOf('@') < 1 || email.indexOf('.') < 3) {
      emailError.textContent = 'Ange en giltig e-postadress.';
      emailError.style.display = 'block';
      return;
    }

    state.firstName = firstName;
    state.email = email;
    emailError.style.display = 'none';
    emailBtn.disabled = true;
    emailBtnText.textContent = 'SKICKAR...';

    var payload = {
      email: email,
      firstName: firstName,
      lastName: lastName,
      gender: state.gender,
      age: state.age,
      height: state.height,
      weight: state.weight,
      daily_activity: state.activity,
      goal: state.goal,
      diabetes: state.diabetes,
      bmr: result.bmr,
      tdee: result.tdee,
      bmi: result.bmi.value,
      target_kcal: (movementResult && movementResult.valid) ? movementResult.targetCalories : result.targetCalories,
      protein_g: (movementResult && movementResult.valid) ? movementResult.macros.protein.grams : result.macros.protein.grams,
      fat_g: (movementResult && movementResult.valid) ? movementResult.macros.fat.grams : result.macros.fat.grams,
      carbs_g: (movementResult && movementResult.valid) ? movementResult.macros.carbs.grams : result.macros.carbs.grams,
      exercise_kcal: (movementResult && movementResult.valid) ? minExerciseKcal : 0,
      algorithm: state.diabetes ? 'BTS' : 'MTH'
    };

    // OVISST ÄR DEFAULT. Så fort requesten är AVSÄND vet vi inte längre vad
    // servern hann göra: nätverksfel, trasig JSON-kropp och kodlös 5xx kastar
    // innan något utfall avkodats. Bara ett BEVISAT utfall sänker flaggan.
    //
    // KVITTERAD är en EGEN flagga, satt i SAMMA sats som utfallet avgörs och
    // läst FÖRST i felgrenen. Ett kast i renderingen efter en bekräftad sparning
    // är ett VISNINGSFEL, aldrig ett persistensfel, och får varken omklassas
    // till ovisst eller kvittera "kunde inte spara".
    var kvitterad = false;
    var renderfel = false;
    var oviss = true;
    var serverText = '';
    baselineState = 'inflight';

    // TIDSGRÄNS. Uteblir svaret helt körs varken then eller catch, och
    // formuläret låg kvar i SKICKAR... tills kunden laddade om och tappade allt.
    /* TIDSGRÄNSEN MÅSTE BITA ÄVEN UTAN AbortController. Avbrottet var enda
       mekanismen, så i en webview utan API:t var timern en funktion som inte
       gjorde något: uteblev svaret körde varken then eller catch, och vyn låg
       kvar i pågående läge för alltid. Kapplöpningen ger tidsgränsen verkan
       oavsett: finns avbrottet frigörs dessutom uppkopplingen. */
    var baselineAbort = (typeof AbortController === 'function') ? new AbortController() : null;
    var baselineTimeout = null;
    var baselineTak = new Promise(function(_, avvisa) {
      baselineTimeout = setTimeout(function() {
        if (baselineAbort) baselineAbort.abort();
        avvisa(new Error('baseline_unknown'));
      }, 15000);
    });

    // RACET OMFATTAR HELA KEDJAN, fetch OCH kroppsläsningen. Låg det bara runt
    // fetch settlade racet när SVARSHUVUDENA kom, och en kropp som aldrig tar
    // slut hängde flödet efter det: tidsgränsen var förbi och utan
    // AbortController fanns inget som bröt. Kroppen läses OAVSETT status,
    // eftersom workern lägger sitt stegkvitto där (partial, failedStep,
    // profileSaved ...) med 422 eller 500 som status.
    Promise.race([
      fetch(API_URL + '/baseline-submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        signal: baselineAbort ? baselineAbort.signal : undefined,
        body: JSON.stringify(payload)
      }).then(function(res) {
        return res.json().then(function(data) { return { data: data, status: res.status }; },
          function() { throw new Error('baseline_unknown'); });
      }),
      baselineTak
    ])
    .then(function(svar) {
      var data = svar.data;
      serverText = (data && data.error) || '';

      // BOOLEAN-STRIKT, ingen truthiness. Workern svarar ALDRIG 2xx på ett
      // avslag, så ett 2xx utan success === true är ett svar vi inte kan tolka:
      // OKÄNT, aldrig "misslyckat".
      if (svar.status < 300 && data && data.success === true) {
        kvitterad = true;
        oviss = false;
        pushTracking('baseline_email_submit');
        revealMacroPlan();
        return;
      }

      // Något ligger redan i Shopify: ovisst kvarstår, och beskedet ber om
      // omladdning i stället för en ny inskickning.
      if (data && data.partial === true) throw new Error('baseline_unknown');

      // 4xx UTAN committat steg är ett BEVISAT avslag: valideringsfel, avvisad
      // mutation eller throttling innan något hann ske. Där är ett nytt försök
      // meningsfullt. 5xx och 2xx-utan-success är okända.
      if (svar.status >= 400 && svar.status < 500) {
        oviss = false;
        throw new Error('baseline_rejected');
      }
      throw new Error('baseline_unknown');
    })
    .catch(function(err) {
      // KVITTERAD LÄSES FÖRST. Allt som kastar härefter är visning.
      if (kvitterad) {
        renderfel = true;
        emailError.textContent = 'Din profil sparades, men sidan kunde inte uppdateras. Ladda om sidan.';
        emailError.style.display = 'block';
        return;
      }
      // Ingen browsertext ut i gränssnittet: avbrott, nätverksfel och trasig
      // JSON bär engelska. Och ett okänt utfall påstår aldrig osparat.
      var avvisad = err && err.message === 'baseline_rejected';
      emailError.textContent = serverText || (avvisad
        ? 'Kunde inte skicka. Kontrollera uppgifterna och försök igen.'
        : 'Vi kunde inte bekräfta att din profil sparades. Ladda om sidan för att se aktuellt läge.');
      emailError.style.display = 'block';
    })
    .finally(function() {
      clearTimeout(baselineTimeout);
      // Låst tills omladdning vid ovisst utfall OCH vid renderfel efter kvittens:
      // vyn speglar då inte det servern håller, och en ny inskickning skulle
      // posta hela profilen en gång till.
      var last = oviss || renderfel;
      baselineState = last ? 'unknown' : 'idle';
      if (!last) emailBtn.disabled = false;
      emailBtnText.textContent = 'VISA MIN F\u00D6RDELNING';
    });
  }

  /* ── Reveal S5 + S6 ── */
  function revealMacroPlan() {
    /* Re-rendera makrokort (teaser hade redan renderat, nu med sliders) */
    renderMacroCards();
    renderMovementSliders();
    renderNextStep();

    /* Ta bort teaser-blur */
    s5.classList.remove('gh-hp-s5--teaser');

    s5.style.display = 'block';
    s6.style.display = 'block';

    var emailForm = document.getElementById('ghHpEmailForm');
    var emailDone = document.getElementById('ghHpEmailDone');
    if (emailForm) emailForm.style.display = 'none';
    if (emailDone) emailDone.style.display = 'block';

    /* Spara till localStorage for aterbesok */
    saveToLocalStorage();

    setTimeout(function() {
      s5.classList.add('gh-hp-s5--visible');
      s6.classList.add('gh-hp-s6--visible');
      s5.scrollIntoView({ behavior: 'smooth', block: 'start' });
      observeCountUp(s5);
      initMovementSliders();
    }, 100);
  }

  /* ── Logged-in profile: fetch + render ── */
  var customerEmail = '';
  var customerName = '';
  var isLoggedIn = false;

  function checkLoggedInProfile() {
    var s1El = document.getElementById('gh-hp-s1');
    if (!s1El) return;

    customerEmail = (s1El.getAttribute('data-customer-email') || '').trim();
    customerName = (s1El.getAttribute('data-customer-name') || '').trim();

    if (!customerEmail || customerEmail.indexOf('@') < 1) return;
    isLoggedIn = true;

    /* Visa laddningsindikator */
    var s2El = document.getElementById('gh-hp-s2');
    var heroCta = document.getElementById('ghHpHeroCta');
    if (heroCta) {
      heroCta.textContent = 'LADDAR DIN PROFIL...';
      heroCta.style.pointerEvents = 'none';
      heroCta.style.opacity = '0.5';
    }

    fetch(API_URL + '/get-profile', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: '{}'
    })
    .then(function(res) { return res.ok ? res.json() : null; })
    .then(function(data) {
      if (!data || !data.success || !data.profile) {
        resetHeroForForm();
        return;
      }

      var p = data.profile;

      /* Kolla om profilen har beraknade varden */
      if (!p.gh_bmr || !p.gh_tdee || !p.gh_target_kcal) {
        resetHeroForForm();
        return;
      }

      /* Populera state fran sparad profil */
      state.gender = p.gh_gender || null;
      state.age = p.gh_age || null;
      state.height = p.gh_height || null;
      state.weight = p.gh_weight || null;
      state.activity = p.gh_daily_activity || null;
      state.goal = p.gh_goal || null;
      state.diabetes = (p.gh_has_diabetes == 'Ja');
      state.email = customerEmail;
      state.firstName = customerName;

      /* Omberakna via algoritmen for att fa movement-data (v2.5) */
      var exerciseKcal = parseInt(p.gh_exercise_kcal) || 0;
      savedExerciseKcal = exerciseKcal;
      /* Kundens sparade PAL-justering vinner över formulärets vardagsrörelse i
         beräkningen, precis som i workern som lagrade talen (issue #134). Utan
         den visade sidan siffror för ett PAL kunden själv justerat bort.
         Beräkningen går genom den DELADE regeln, inte genom en lokal
         jämförelse: då gäller samma strikta domän och samma fullständighetsgrind
         som i workern ('04' är en lucka, och en saknad vardagsrörelse räknas
         inte om). state.activity står kvar RÅTT: det är fältet
         gh_daily_activity och får aldrig skrivas om av en visning. */
      var deladPalregel = harDeladPalregel();
      savedAdjustedPal = deladPalregel ? GHAlgorithm.giltigtPal(p.gh_adjusted_pal) : null;
      var palAttRakna = deladPalregel
        ? GHAlgorithm.effektivtPal(p.gh_adjusted_pal, state.activity)
        : state.activity;
      var calcResult = GHAlgorithm.calculate({
        gender: state.gender,
        age: state.age,
        weight: state.weight,
        height: state.height,
        activityLevel: palAttRakna,
        goal: state.goal,
        algorithm: state.diabetes ? 'BTS' : 'MTH',
        btsLevel: 1,
        hasDiabetes: state.diabetes,
        exerciseKcal: exerciseKcal
      });

      if (calcResult && calcResult.valid) {
        result = calcResult;
      } else {
        /* Fallback: bygg result-objekt manuellt */
        var bmiVal = p.gh_bmi || 0;
        var bmiCat = '';
        if (bmiVal < 18.5) bmiCat = 'Undervikt';
        else if (bmiVal < 25) bmiCat = 'Normalvikt';
        else if (bmiVal < 30) bmiCat = '\u00D6vervikt';
        else bmiCat = 'Fetma';

        result = {
          valid: true,
          bmr: p.gh_bmr,
          tdee: p.gh_tdee,
          targetCalories: p.gh_target_kcal,
          bmi: { value: bmiVal, category: bmiCat },
          macros: {
            protein: { grams: p.gh_protein_g || 0, percent: 0 },
            fat: { grams: p.gh_fat_g || 0, percent: 0 },
            carbs: { grams: p.gh_carbs_g || 0, percent: 0 }
          },
          safeguard: {
            showDisclaimer: (bmiVal < 18.5 || bmiVal >= 35)
          }
        };

        if (result.targetCalories > 0) {
          result.macros.protein.percent = Math.round((result.macros.protein.grams * 4 / result.targetCalories) * 100);
          result.macros.fat.percent = Math.round((result.macros.fat.grams * 9 / result.targetCalories) * 100);
          result.macros.carbs.percent = 100 - result.macros.protein.percent - result.macros.fat.percent;
        }
      }

      /* Rendera direkt: hoppa over formular */
      renderSavedProfile();

      /* Visit tracking: fire-and-forget */
      fetch(API_URL + '/track-visit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ page: 'halsoprofil' })
      }).catch(function() {});
    })
    .catch(function() {
      resetHeroForForm();
    });
  }

  function resetHeroForForm() {
    var heroCta = document.getElementById('ghHpHeroCta');
    if (heroCta) {
      heroCta.textContent = 'R\u00C4KNA UT MIN PROFIL';
      heroCta.style.pointerEvents = '';
      heroCta.style.opacity = '';
    }
  }

  function renderSavedProfile() {
    /* Dolj S1 hero + S2 formular */
    var s1El = document.getElementById('gh-hp-s1');
    var s2El = document.getElementById('gh-hp-s2');
    if (s1El) s1El.style.display = 'none';
    if (s2El) s2El.style.display = 'none';

    /* Rendera S3 (baseline cards + tolkning) */
    renderBaselineCards();
    renderInterpretation();
    s3.style.display = 'block';

    /* Lagg till "Gor om berakningen"-knapp i S3 */
    addRedoButton();

    /* Rendera S5 (makros + sliders) + S6 (nasta steg) direkt, ingen email-gate */
    renderMacroCards();
    renderMovementSliders();
    renderNextStep();
    s5.style.display = 'block';
    s5.classList.add('gh-hp-s5--visible');
    s6.style.display = 'block';
    s6.classList.add('gh-hp-s6--visible');

    /* S4 doljs helt: inloggad behover inte email-gate */
    if (s4) s4.style.display = 'none';

    /* Kör countup-animation + init sliders */
    setTimeout(function() {
      observeCountUp(s3);
      observeCountUp(s5);
      initMovementSliders();
    }, 100);

    /* Scrolla till S3 */
    setTimeout(function() {
      s3.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 200);
  }

  function addRedoButton() {
    if (!s3) return;
    var inner = s3.querySelector('.gh-hp-s3__inner');
    if (!inner) return;

    /* Kolla om knappen redan finns */
    if (inner.querySelector('.gh-hp-s3__redo-btn')) return;

    var wrapper = document.createElement('div');
    wrapper.style.cssText = 'text-align:center;margin-top:44px;';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'gh-hp-s3__redo-btn';
    btn.style.cssText = 'display:inline-block;padding:14px 36px;font-family:inherit;font-size:12px;font-weight:800;letter-spacing:0.12em;text-transform:uppercase;color:#858586;background:transparent;border:1px solid #333;cursor:pointer;transition:border-color .15s,color .15s;';
    btn.textContent = 'G\u00D6R OM BER\u00C4KNINGEN';

    btn.addEventListener('mouseenter', function() {
      btn.style.borderColor = '#11cfc9';
      btn.style.color = '#11cfc9';
    });
    btn.addEventListener('mouseleave', function() {
      btn.style.borderColor = '#333';
      btn.style.color = '#858586';
    });
    btn.addEventListener('click', function() {
      startRedoCalculation();
    });

    wrapper.appendChild(btn);

    /* Lagg till fore trust-elementet */
    var trust = inner.querySelector('.gh-hp-s3__trust');
    if (trust) {
      inner.insertBefore(wrapper, trust);
    } else {
      inner.appendChild(wrapper);
    }
  }

  function startRedoCalculation() {
    /* Rensa localStorage sa att ny berakning startar fran scratch */
    clearLocalStorage();

    /* Visa S1 + S2, dolj resultat */
    var s1El = document.getElementById('gh-hp-s1');
    var s2El = document.getElementById('gh-hp-s2');
    if (s1El) s1El.style.display = '';
    if (s2El) s2El.style.display = '';

    s3.style.display = 'none';
    if (s4) s4.style.display = 'none';
    s5.style.display = 'none';
    s5.classList.remove('gh-hp-s5--visible');
    s6.style.display = 'none';
    s6.classList.remove('gh-hp-s6--visible');

    /* Ta bort redo-knappen */
    var redoWrapper = s3.querySelector('.gh-hp-s3__redo-btn');
    if (redoWrapper && redoWrapper.parentNode) redoWrapper.parentNode.remove();

    /* Rensa state */
    state.step = 1;
    state.gender = null;
    state.age = null;
    state.height = null;
    state.weight = null;
    state.activity = null;
    state.goal = null;
    state.diabetes = null;
    result = null;
    /* Den sparade PAL-justeringen hör till den PROFIL som just lämnades. Görs
       beräkningen om från formuläret är vardagsrörelsen där det enda svaret,
       annars hade reglaget och korten visat en justering för gamla siffror. */
    savedAdjustedPal = null;

    resetHeroForForm();
    goToStep(1);
    updateProgress();

    /* Scrolla till toppen */
    s1El.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  /* ── localStorage persistence ── */
  var LS_KEY = 'gh_hp_saved';

  function saveToLocalStorage() {
    if (!result || !state.email) return;
    try {
      var data = {
        ts: Date.now(),
        email: state.email,
        firstName: state.firstName || '',
        gender: state.gender,
        age: state.age,
        height: state.height,
        weight: state.weight,
        activity: state.activity,
        goal: state.goal,
        diabetes: state.diabetes,
        bmr: result.bmr,
        tdee: result.tdee,
        bmi: result.bmi.value,
        bmiCategory: result.bmi.category,
        targetCalories: (movementResult && movementResult.valid) ? movementResult.targetCalories : result.targetCalories,
        protein: (movementResult && movementResult.valid) ? movementResult.macros.protein.grams : result.macros.protein.grams,
        fat: (movementResult && movementResult.valid) ? movementResult.macros.fat.grams : result.macros.fat.grams,
        carbs: (movementResult && movementResult.valid) ? movementResult.macros.carbs.grams : result.macros.carbs.grams,
        proteinPct: (movementResult && movementResult.valid) ? movementResult.macros.protein.percent : result.macros.protein.percent,
        fatPct: (movementResult && movementResult.valid) ? movementResult.macros.fat.percent : result.macros.fat.percent,
        carbsPct: (movementResult && movementResult.valid) ? movementResult.macros.carbs.percent : result.macros.carbs.percent,
        showDisclaimer: result.safeguard && result.safeguard.showDisclaimer,
        exerciseKcal: (movementResult && movementResult.valid) ? minExerciseKcal : 0,
        adjustedPAL: state.activity
      };
      localStorage.setItem(LS_KEY, JSON.stringify(data));
    } catch (e) { /* quota full or private mode */ }
  }

  function loadFromLocalStorage() {
    try {
      var raw = localStorage.getItem(LS_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      /* Max 90 dagar gammalt */
      if (!data.ts || (Date.now() - data.ts) > 90 * 24 * 60 * 60 * 1000) {
        localStorage.removeItem(LS_KEY);
        return null;
      }
      return data;
    } catch (e) { return null; }
  }

  function clearLocalStorage() {
    try { localStorage.removeItem(LS_KEY); } catch (e) { /* ok */ }
  }

  function restoreFromLocalStorage(data) {
    /* Populera state */
    state.gender = data.gender;
    state.age = data.age;
    state.height = data.height;
    state.weight = data.weight;
    state.activity = data.activity;
    state.goal = data.goal;
    state.diabetes = data.diabetes;
    state.email = data.email;
    state.firstName = data.firstName || '';
    savedExerciseKcal = parseInt(data.exerciseKcal) || 0;
    /* localStorage-vägen är den anonyma besökarens och bär ingen sparad
       PAL-justering: en kvarliggande justering från en inloggad läsning skulle
       annars räknas in i fel profil. */
    savedAdjustedPal = null;

    /* Berakna ALLTID med exerciseKcal=0 forst (basfall) */
    var calcResult = GHAlgorithm.calculate({
      gender: state.gender,
      age: state.age,
      weight: state.weight,
      height: state.height,
      activityLevel: state.activity,
      goal: state.goal,
      algorithm: state.diabetes ? 'BTS' : 'MTH',
      btsLevel: 1,
      hasDiabetes: state.diabetes,
      exerciseKcal: 0
    });

    if (calcResult && calcResult.valid) {
      result = calcResult;
    } else {
      /* Fallback: bygg result-objekt manuellt (ej movement) */
      result = {
        valid: true,
        bmr: data.bmr,
        tdee: data.tdee,
        targetCalories: data.targetCalories,
        bmi: { value: data.bmi, category: data.bmiCategory },
        macros: {
          protein: { grams: data.protein, percent: data.proteinPct },
          fat: { grams: data.fat, percent: data.fatPct },
          carbs: { grams: data.carbs, percent: data.carbsPct }
        },
        safeguard: {
          showDisclaimer: data.showDisclaimer
        }
      };
    }

    /* Berakna minExercise DIREKT via publik funktion (undviker minifierings-bugg) */
    movementResult = null;
    minExerciseKcal = GHAlgorithm.calculateMinExercise(
      state.gender, parseInt(state.age), parseFloat(state.weight), parseFloat(state.height),
      parseInt(state.activity), state.goal, state.diabetes ? 'BTS' : 'MTH', 1
    ) || 0;
    if (minExerciseKcal > 0) {
      movementResult = GHAlgorithm.calculate({
        gender: state.gender,
        age: state.age,
        weight: state.weight,
        height: state.height,
        activityLevel: state.activity,
        goal: state.goal,
        algorithm: state.diabetes ? 'BTS' : 'MTH',
        btsLevel: 1,
        hasDiabetes: state.diabetes,
        exerciseKcal: minExerciseKcal
      });
    }

    /* Rendera sparad profil */
    renderSavedProfile();

    /* Inget besöksanrop härifrån: localStorage-profilen bär ingen inloggning, och
       /track-visit är en medlemsväg sedan #32. Den inloggade kundens besök räknas
       i grenen som läser profilen från servern. */
  }

  /* ── Tracking ── */
  function pushTracking(event) {
    if (window.dataLayer) {
      window.dataLayer.push({ event: event });
    }
  }

  /* ── Init: Bind events ── */
  function init() {
    var heroCta = document.getElementById('ghHpHeroCta');
    if (heroCta) {
      heroCta.addEventListener('click', function(e) {
        e.preventDefault();
        var s2 = document.getElementById('gh-hp-s2');
        if (s2) s2.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    var genderBtns = stepsContainer.querySelectorAll('.gh-hp-s2__gender-btn');
    for (var g = 0; g < genderBtns.length; g++) {
      genderBtns[g].addEventListener('click', function() {
        handleGender(this.getAttribute('data-value'));
      });
    }

    var nextBtns = stepsContainer.querySelectorAll('.gh-hp-s2__next-btn');
    for (var n = 0; n < nextBtns.length; n++) {
      nextBtns[n].addEventListener('click', function() {
        var field = this.getAttribute('data-field');
        var min = parseInt(this.getAttribute('data-min'));
        var max = parseInt(this.getAttribute('data-max'));
        handleNumericNext(field, min, max);
      });
    }

    var numericInputs = stepsContainer.querySelectorAll('input[type="number"]');
    for (var ni = 0; ni < numericInputs.length; ni++) {
      numericInputs[ni].addEventListener('keydown', function(e) {
        if (e.key == 'Enter' || e.keyCode == 13) {
          e.preventDefault();
          var btn = this.closest('.gh-hp-s2__step').querySelector('.gh-hp-s2__next-btn');
          if (btn) btn.click();
        }
      });
    }

    var actCards = stepsContainer.querySelectorAll('.gh-hp-s2__activity-card');
    for (var a = 0; a < actCards.length; a++) {
      actCards[a].addEventListener('click', function() {
        handleActivity(parseInt(this.getAttribute('data-value')));
      });
    }

    var goalBtns = stepsContainer.querySelectorAll('.gh-hp-s2__goal-btn');
    for (var gb = 0; gb < goalBtns.length; gb++) {
      goalBtns[gb].addEventListener('click', function() {
        handleGoal(this.getAttribute('data-value'));
      });
    }

    var diabetesBtns = stepsContainer.querySelectorAll('.gh-hp-s2__diabetes-btn');
    for (var db = 0; db < diabetesBtns.length; db++) {
      diabetesBtns[db].addEventListener('click', function() {
        handleDiabetes(this.getAttribute('data-value'));
      });
    }

    var showProfileBtn = document.getElementById('ghHpShowProfile');
    if (showProfileBtn) {
      showProfileBtn.addEventListener('click', function() {
        handleShowProfile();
      });
    }

    var backBtns = stepsContainer.querySelectorAll('.gh-hp-s2__back');
    for (var bb = 0; bb < backBtns.length; bb++) {
      backBtns[bb].addEventListener('click', function(e) {
        e.preventDefault();
        goBack();
      });
    }

    if (emailBtn) {
      emailBtn.addEventListener('click', function(e) {
        e.preventDefault();
        handleEmailSubmit();
      });
    }
    if (emailInput) {
      emailInput.addEventListener('keydown', function(e) {
        if (e.key == 'Enter' || e.keyCode == 13) {
          e.preventDefault();
          handleEmailSubmit();
        }
      });
    }

    var s6Cta = document.getElementById('ghHpS6Cta');
    if (s6Cta) {
      s6Cta.addEventListener('click', function() {
        pushTracking('baseline_program_click');
      });
    }

    goToStep(1);
    updateProgress();

    /* 1. Inloggad? Hamta alltid fran server (servern ar master) */
    var s1El = document.getElementById('gh-hp-s1');
    var hasCustomerEmail = s1El && (s1El.getAttribute('data-customer-email') || '').trim().indexOf('@') > 0;
    if (hasCustomerEmail) {
      checkLoggedInProfile();
      return;
    }

    /* 2. Ej inloggad: kolla localStorage (leads som besokter igen) */
    var savedLocal = loadFromLocalStorage();
    if (savedLocal) {
      restoreFromLocalStorage(savedLocal);
      return;
    }
  }

  /* ── Start ── */
  if (document.readyState == 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
